<mee-vertical-datum [placeholder]="'companies.form.DefaultCoordinateSystem.GnssDatum' | translate" [formControl]="gnssControl"></mee-vertical-datum>
